import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { ColDef } from "ag-grid-community";

interface RowData {
  id?: string;
  name: string;
  customer?: string;
  totalScheduled: string;
  percentScheduled?: number;
  billed: string;
  notBilled: string;
  notAllocated?: string;
  projection?: string;
  unavailability?: string;
}

interface GridToPrintProps {
  rows: RowData[];
  columns: ColDef[];
  typeGrid: "default" | "resources";
  columnName?: string;
}

export function GridToPrint({
  columns,
  rows,
  typeGrid,
  columnName = "",
}: GridToPrintProps) {
  return (
    <TableContainer className="only-print" component={Box}>
      <Table sx={{ minWidth: 650 }} size="small">
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell
                key={column.headerName}
                align={column.field === "name" ? "left" : "right"}
              >
                {column.headerName}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {typeGrid === "resources"
            ? rows.map((row) => (
              <TableRow key={row.id}>
                <TableCell align="left">{row?.name}</TableCell>
                <TableCell align="right">{row?.totalScheduled}</TableCell>
                <TableCell align="right">{row?.billed}</TableCell>
                <TableCell align="right">{row?.notBilled}</TableCell>
                <TableCell align="right">{row?.unavailability}</TableCell>
                <TableCell align="right">{row?.notAllocated}</TableCell>
                <TableCell align="right">{row?.projection}</TableCell>
                <TableCell align="right">
                  {row.percentScheduled?.toFixed(1)}%
                </TableCell>
              </TableRow>
            ))
            : rows.map((row) => (
              <TableRow key={row.id}>
                <TableCell align="left">{row?.name}</TableCell>
                {columnName === "Projeto" && (
                  <TableCell align="right">{row?.customer}</TableCell>
                )}
                <TableCell align="right">{row?.totalScheduled}</TableCell>
                <TableCell align="right">{row?.billed}</TableCell>
                <TableCell align="right">{row?.notBilled}</TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
